import { apiClient } from './axiosInstance';

export const fetchHolidaysFilterList = async () => {
  return await apiClient.get(`/holidays/base/holidays`);
};
